import API from 'types/api';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case API.GET_TRANSLATE_SUCCESS:
      return { ...state, ...payload };
    default:
      return state;
  }
};
